import { OrderApi } from '@linktivity/hirakuza';
import config from '../config';

const orderApi = new OrderApi(config);

export default orderApi;
